import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { LastCommentDashboard } from './commentDashboard';
import { PendingTaskList } from './PendingTaskList';
// import PendingApprovalRequestMockup from './PendingApprove/PendingApprovalRequestMockup';
import { useSelector } from 'react-redux';
import { AppState } from '../../../state/configureStore';
import { AuthState } from '../../../state/auth';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    padding: '0.05px',
    position: 'relative',
    overflow: 'visible',
  },
}));

const Dashboard = () => {
  const classes = useStyles();

  useSelector<AppState, AuthState>((state) => state.auth);

  return (
    // <Box className={classes.root}>
    <Grid
      container
      spacing={3}
      direction="row"
      justifyContent="center"
      className={classes.root}
    >
      <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
        {/* {isLoggedIn &&
          (user?.roles?.includes('MANAGER') || user?.roles?.includes('ADMIN')) && (
            <Grid item md={12}>
              <PendingApproveTask />
            </Grid>
          )} */}
        <Grid item md={12}>
          <LastCommentDashboard />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
        {/* <Grid item md={12}>
          <SubtaskStatus />
        </Grid> */}
        <PendingTaskList />
      </Grid>

      {/* TODO: Implement PendingApprovalRequest */}
      {/* <Grid item xs={12}>
        <PendingApprovalRequestMockup />
      </Grid> */}
    </Grid>
    // </Box>
  );
};

export default Dashboard;
